var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0713FAFE-EADB-4B58-8C73-4479D1AC71EA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-137.000000, -928.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "access",
    transform: "translate(138.952148, 929.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54003906,12.2785645 C10.6429462,13.0040681 12.6290266,14 14.0478516,14 C17.9138448,14 21.0478516,10.8659932 21.0478516,7 C21.0478516,3.13400675 17.9138448,0 14.0478516,0 C10.1818583,0 7.04785156,3.13400675 7.04785156,7 C7.04785156,7.7472018 7.05993143,9.30871457 7.2767334,9.98388672",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 15.5478516,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-70",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "7.53925032 9 0 16.4732796 0 22 4.71960553 22 4.71960553 18.9353547 7.53925032 18.9353547 7.53925032 15.9801351 10 15.9801351 10 13.0694151"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAccess);
export default __webpack_public_path__ + "static/media/ico_access.228fc646e1e2d4c27409033080fa760c.svg";
export { ForwardRef as ReactComponent };